import { FC, memo, useEffect, useRef, useState } from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';

import AddModal from './AddModal';
import MainLayout from '../../../../shared/common/components/layouts/MainLayout';
import PageHead from '../../../../shared/common/components/page-header/PageHeader';
import { QUERY_NAME_DASHBOARD } from '../../../../shared/common/constants/query-params';
import { routeNames } from '../../../../shared/common/constants/routes';
import { useActions } from '../../../../shared/common/hooks/useActions';
import { useTypedSelector } from '../../../../shared/common/hooks/useTypedSelector';

const SchoolAdd: FC = () => {
  const [ searchParams, setSearchParams ] = useSearchParams();
  const [ addModalVisible, setAddModalVisible ] = useState(false);
  const { setAppReportOpen, setDrawerLink } = useActions();

  const navigate = useNavigate();
  const isMounted = useRef(false);

  const { userAccess } = useTypedSelector((state) => state.currentSchool);
  const currentUser = useTypedSelector((state) => state.currentUser);

  const connectStagesBtn = (
    <Button
      onClick={() => {
        setDrawerLink(
          `https://doc.scananalytics.ru/o-servise-i-nachalo-raboty/etapy-nastrojki/?timestamp=${new Date().getTime()}`
        );
        setAppReportOpen(true);
      }}
      style={{ border: '1px solid black' }}
      shape="round"
      type="default"
    >
      Этапы подключения
    </Button>
  );

  useEffect(() => {
    if (searchParams.get(QUERY_NAME_DASHBOARD)) setSearchParams({});
  }, [ searchParams ]);

  useEffect(() => {
    if (isMounted.current) {
      if (userAccess?.status) {
        navigate(routeNames.home);
      }
      if (userAccess === null && !currentUser.id) {
        navigate(routeNames.error);
      }
    } else {
      isMounted.current = true;
    }
  }, [ userAccess, currentUser.id ]);

  return (
    <MainLayout pageTitle="Добавить школу">
      <div className="page-wrapper">
        <PageHead
          title="Подключение новой школы"
          extraContent={connectStagesBtn}
        />

        <div className="page-content">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setAddModalVisible(true)}
          >
            Добавить школу GetCourse
          </Button>
        </div>

        <AddModal isVisible={addModalVisible} setVisible={setAddModalVisible} />
      </div>
    </MainLayout>
  );
};

export default memo(SchoolAdd);
